export function recordKeys(record) {
    return Object.keys(record);
}
